import type React from 'react';

import { PlusIcon } from '@vlabs/icons';
import { PageHeader, usePageContext } from '@vlabs/monokit/shared/ui/page';
import { useHasPermission } from '@vlabs/permissions';
import { Button } from '@vlabs/uikit/components/controls/button';

import { useHandlerListTranslation } from './handlerListI18n';

interface HandlerListPageHeaderProps {
  onCreateHandler: VoidFunction;
}

function HandlerListPageHeader({
  onCreateHandler,
}: HandlerListPageHeaderProps): React.JSX.Element {
  const { t } = useHandlerListTranslation();
  const pageContext = usePageContext();
  const canCreate = useHasPermission('handler', 'create');

  return (
    <PageHeader
      actions={canCreate ? (
        <Button
          data-testid="table.createHandlerButton"
          icon={<PlusIcon />}
          onClick={onCreateHandler}
          size={pageContext.buttonSize}
        >
          {t('actions.add')}
        </Button>
      ) : undefined}
      title={t('title')}
    />
  );
}

export { HandlerListPageHeader };
